import "./thankYou.css";
import { Loader, thankyou } from "../../../assets/images";
import { thankuleft } from "../../../assets/images";
import { withTranslation } from "react-i18next";
import useThankYouHook from "../thankYou/useThankYou";
import { commaValidation } from "../../../utility";

const ThankYou = (props) => {
  const {
    bookingData,
    // diffDate,
    loader,
    navigateToMyAccount,
    calculateDifference,
  } = useThankYouHook();
  const { t } = props;

  const thankyoupage = () => {
    return (
      <div className="thank_umain flt">
        <div className="thanku_img flt">
          <img src={thankyou} alt="thank" />
        </div>
        <div className="thanku_booking flt">{t("Thank_Booking")}</div>
        {/* <div className="thanku_content flt">
                    {t("Please_see_the_booking_details_below_&")}<span onClick={navigateToMyAccount} type="button">{t("my_account")}.</span></div> */}
        <div className="thanku_row flt">
          <div className="row">
            <div className="col-sm-2"></div>
            <div className="col-sm-3">
              <div className="thanku_leftimg flt">
                <img src={thankuleft} alt="thank" />
              </div>
            </div>
            <div className="col-sm-5 ">
              {bookingData?.map((data, index) => (
                <div className="thanku_right  flt">
                  <ul className="thanku_cont" key={index}>
                    <li>Total Adults</li>
                    <li>
                      {data?.adults /
                        calculateDifference(
                          data?.arrival_date,
                          data?.departure_date
                        ) -
                        data?.rooms?.reduce(
                          (sum, room) =>
                            sum + (room.infantsAbove8?.length || 0),
                          0
                        ) /
                          calculateDifference(
                            data?.arrival_date,
                            data?.departure_date
                          )}
                    </li>
                    <li>Total Children</li>
                    <li>
                      {data?.rooms?.reduce(
                        (sum, room) => sum + (room.infants?.length || 0),
                        0
                      ) /
                        calculateDifference(
                          data?.arrival_date,
                          data?.departure_date
                        )}
                    </li>
                    <li>{t("Total_Rooms")}</li>
                    <li>
                      {data?.rooms.length /
                        calculateDifference(
                          data?.arrival_date,
                          data?.departure_date
                        )}
                    </li>
                    <li>{t("Check_In")}</li>
                    <li>{data?.arrival_date}</li>
                    <li>{t("Check_Out")}</li>
                    <li>{data?.departure_date}</li>
                    <li>{t("Total_Length")}</li>
                    <li>
                      {calculateDifference(
                        data?.arrival_date,
                        data?.departure_date
                      )}
                    </li>
                    {/* <li>{t("Amount_Paid")}</li> */}
                    {/* <li>{`₹ ${commaValidation(Number(data?.roomCharge))}`}</li> */}
                  </ul>
                </div>
              ))}
              <div className="thanku_right totalAmt  flt">
                <ul className="thanku_cont">
                  <li>
                    <b>Total Amount Paid</b>
                  </li>
                  <li>{`₹ ${commaValidation(
                    Number(bookingData[0]?.roomCharge)
                  )}`}</li>
                </ul>
              </div>
            </div>

            {/* <div className="col-sm-5">
              <div className="thanku_right flt">
                <ul className="thanku_cont">
                  <li>{t("Total_Guest")}</li>
                  <li>{bookingData?.[0]?.adults}</li>
                  <li>{t("Total_Rooms")}</li>
                  <li>
                    {bookingData?.[0]?.no_of_room
                      ? bookingData?.data?.[0]?.no_of_room
                      : "0"}
                  </li>
                  <li>{t("Check_In")}</li>
                  <li>{bookingData?.[0]?.arrival_date}</li>
                  <li>{t("Check_Out")}</li>
                  <li>{bookingData?.[0]?.departure_date}</li>
                  <li>{t("Total_Length")}</li>
                  <li>
                    {bookingData?.[0]?.total_length
                      ? bookingData?.[0]?.total_length
                      : "0"}
                  </li>
                  <li>{t("Amount_Paid")}</li>
                  <li>{`₹ ${commaValidation(
                    Number(bookingData?.[0]?.total_price)
                  )}`}</li>
                </ul>
              </div>
            </div> */}
            <div className="col-sm-2"></div>
          </div>
          <div className="thanku_questions flt">
            {" "}
            {t("Please_see_the_booking_details_below_&")}
            <span onClick={navigateToMyAccount} type="button">
              {t("my_account")}.
            </span>
          </div>
        </div>
      </div>
    );
  };
  return (
    <>
      {loader === "loading" && (
        <div className="main_load ">
          <img src={Loader} alt="loader" />
        </div>
      )}
      {loader !== "loading" && (
        <div className="main_container flt">{thankyoupage()}</div>
      )}
    </>
  );
};

export default withTranslation()(ThankYou);
